export const DATE_FORMAT = 'YYYY-MM-DD HH:mm'

export const filterObjects = [
  {
    key: 'scenarioPurgerName',
    title: 'Filter.Name'
  },
  {
    key: 'username',
    title: 'Filter.Users'
  },
  {
    key: 'scenarioType',
    title: 'Filter.Type'
  }
]

export const ISO_DATE_FORMAT = 'YYYY/MM/DD'

export const CRONTAB_STAGE = 'CRONTAB_STAGE'
export const RULES_STAGE = 'RULES_STAGE'
export const HEADING_LABEL_CRONTAB = 'Crontab'
export const HEADING_LABEL_RULES = 'Build Rule'

export const USERNAME = 'username'
export const SUMMARY = 'summary'
export const PROGRESS = 'progress'
export const NAME = 'name'
export const CONSOLIDATED = 'consolidated'
export const STATUS = 'status'
export const TYPE = 'type'
export const MASTERDATA_NAME = 'masterdataName'
export const PARENT_NAME = 'parentName'
export const CREATION_DATETIME = 'creationDateTime'
export const START_DATETIME = 'startDateTime'
export const END_DATETIME = 'endDateTime'
export const TYPE_VALUE = 'typeValue'
export const ADDITIONAL_COL = 'ADDITIONAL_COL'
export const OLDER_THAN = 'OLDER_THAN'

export const fieldTypes = {
  STRING: 'STRING',
  BOOLEAN: 'BOOLEAN',
  SELECT: 'SELECT',
  NUMBER: 'NUMBER',
  DATE: 'DATE',
  DATE_NUMBER: 'DATE_NUMBER'
}

export const fieldsMap = {
  name: 'name',
  status: 'state',
  progress: 'progress',
  type: 'type_value',
  masterdataName: 'master_instance_id', // hidden,
  parentName: 'cloned_instance_id', // hidden,
  creationDateTime: 'creation_date_time',
  startDateTime: 'start_date_time',
  endDateTime: 'end_date_time'
}

export const excludedColumns = [
  USERNAME,
  SUMMARY,
  PROGRESS,
  CONSOLIDATED,
  MASTERDATA_NAME,
  PARENT_NAME
]

export const typesByColId = {
  [fieldsMap[NAME]]: fieldTypes.STRING,
  [fieldsMap[STATUS]]: fieldTypes.SELECT,
  [fieldsMap[TYPE]]: fieldTypes.SELECT,
  [fieldsMap[MASTERDATA_NAME]]: fieldTypes.SELECT,
  [fieldsMap[PARENT_NAME]]: fieldTypes.STRING,
  [fieldsMap[CREATION_DATETIME]]: fieldTypes.DATE,
  [fieldsMap[START_DATETIME]]: fieldTypes.DATE,
  [fieldsMap[END_DATETIME]]: fieldTypes.DATE,
  [fieldsMap[ADDITIONAL_COL] ?? ADDITIONAL_COL]: fieldTypes.STRING // We can't know what kind of field it'll be,
}
